import {Green4, Grey17, Grey6, Red3} from "../../theme/styles";

import {EnlilTable} from "../EnlilTable";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import EventBus from "../../util/EventBus";
import {Chip, IconButton, Menu, MenuItem, Typography} from "@mui/material";
import {Delete, Edit, MoreVert} from "@mui/icons-material";
import css_self from "../Navigation/css/NavBar.module.scss";
import React from "react";
import {withAppContext} from "../../util/withAppContext";
import DeveloperSubscriptionFormApplet from "../../eoec/applet/impl/SubscriptionManagement/DeveloperSubscriptionFormApplet";

class DeveloperSubscriptionTable extends EnlilTable {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("developer-subscription-form-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("developer-subscription-form-applet-save", this.onCancelHandler);
    }

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("developer-subscription-form-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("developer-subscription-form-applet-save", this.onCancelHandler);
    }

    enterpriseComponentInsertCompleted(ec) {
        super.enterpriseComponentInsertCompleted(ec)

        ec.invalidateChildren();
    }

    enterpriseComponentDeleteCompleted(ec) {
        super.enterpriseComponentDeleteCompleted(ec)

        ec.invalidateChildren();
    }

    getCellRenderer(name) {
        if (name === "Action Cell") {
            return this.renderActionCell;
        } else if (name === "Subscription Status Cell") {
            return this.renderStatusCell;
        } else if (name === "Event Type") {
            return this.renderEventTypeCell;
        }
        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "New Subscription") {
            this.setState({renderTarget: "New Subscription"});
        }
        super.handleMenuClick(identifier);
    }

    renderExtension() {
        if (this.state.renderTarget === "New Subscription") {
            return <DeveloperSubscriptionFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="New" />;
        }
        if (this.state.renderTarget === "Edit Subscription") {
            return <DeveloperSubscriptionFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Edit" />;
        }
        if (this.state.renderTarget === "Delete Subscription") {
            return <DeveloperSubscriptionFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Delete" />;
        }
    };

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderStatusCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let backgroundColor;

        let statusValue;
        if (this.state.buffer[params.row.id].get("Status") === 'Inactive') {
            backgroundColor = Red3;
            statusValue = "Inactive"
        } else {
            backgroundColor = Green4;
            statusValue = "Active"
        }
        return (
            <div style={{marginTop: "-2px"}}>
                <Chip label={statusValue} size="small" style={{fontSize: 12, backgroundColor: backgroundColor, color: "#FFFFFF", marginTop: 1}} />
            </div>
        );
    };

    renderEventTypeCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{marginTop: "-2px"}}>
                {this.state.buffer[params.row.id].get("EventType")}
            </div>
        );
    };

    renderActionCell = (___, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{width: "50px", marginTop: "-4px", backgroundColor: "#FFFFFF", marginLeft: "-10px", marginRight: "-20px", paddingBottom: "5px", paddingLeft: "4px"}}>
                <IconButton onClick={(event) => {
                    if (this.state.tableActionMenuTarget === null) {
                        this.setState({tableActionMenuTarget: event.currentTarget});
                    } else {
                        this.setState({tableActionMenuTarget: null});
                    }
                }}>
                    <MoreVert />
                </IconButton>
                <Menu anchorEl={this.state.tableActionMenuTarget}
                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                      transformOrigin={{vertical: -10, horizontal: "center"}}
                      open={this.state.tableActionMenuTarget !== null && this.state.tableActionMenuTarget !== undefined}
                      onClose={() => this.setState({tableActionMenuTarget: null})}
                      TransitionProps={{
                          onExited: () => this.setState({tableActionMenuTarget: null}),
                      }}
                      MenuListProps={{
                          ...{"data-cc-component": "NavMenu"},
                          disablePadding: true,
                          style: {"minWidth": "200px"},
                      }}
                      PaperProps={{
                          elevation: 2,
                      }}
                >
                    <MenuItem divider key={"1"} className={css_self.Standard} onClick={() => {
                        this.setState({tableActionMenuTarget: null, renderTarget: "Edit Subscription"});
                    }}>
                        <Edit style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Edit Subscription</Typography>
                    </MenuItem>
                    <MenuItem divider key={"1"} className={css_self.Standard} onClick={() => {
                        this.setState({tableActionMenuTarget: null, renderTarget: "Delete Subscription"});
                    }}>
                        <Delete style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Delete Subscription</Typography>
                    </MenuItem>
                </Menu>
            </div>
        )
    }
}

export default withNavigate(withAppContext(withBreakpoint(DeveloperSubscriptionTable)));